import { type TranslationTree } from '@/i18n/types';

export const messages = {
  legalName: 'Razão social',
  contactName: 'Contato',
  contactEmail: 'E-mail de contato',
  contactPhone: 'Telefone',
  website: 'Site',
  instagram: 'Instagram',
  notInformed: 'Não informado',
  noDescription: 'Sem descrição. Conte em poucas linhas o que a organização faz.',
  locked: 'Travado após a aprovação',
} satisfies TranslationTree;
